import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import Categories from "../common/Categories";
// import Testimonials from "../common/Testimonials";
import { fetchCategoryApiData, fetchProductApiData } from "../../../reduxToolkit/reducers/productSlice";
import CarHomeSection from "./CarHomeSection";
import Product from "./Product";
import Service from "./Service";
// import Offer from "./Offer";
import Work from "./Work";
import ImageSlideshow from "./ImageSlideshow";
import About from "./About";
import client from "../../../feathers"

const CarDemo1Container = () => {
  const dispatch = useAppDispatch();
  const [ products, setProducts ] = useState<any[]>([])
  const [ categories, setCategories ] = useState<any[]>([])

  useEffect(() => {
    dispatch(fetchProductApiData());
    dispatch(fetchCategoryApiData());
  }, [dispatch]);

  const fetchCategoryData = () => {
    return client.service('categories').find({
      query: {
        status: true,
        $limit: 100,
        $sort: {
          createdAt: -1
        }
      }
    })
    .then((res: any) => {
      setCategories(res.data)
    })
    .catch((err: any)=>{
      console.log(err)
    })
  }

  const fetchProductData = () => {
    client.service('products').find({
        query: {
          status: true,
          $limit: 8,
          $sort: {
            createdAt: -1
          }
        }
      })
    .then((res: any) => {
      setProducts(res.data)
    })
    .catch((err: any)=>{
      console.log(err)
    })
  }

  useEffect(() => {
    fetchCategoryData();
    fetchProductData();
  }, [])

  return (
    <>
      <CarHomeSection />
      <Categories 
        type={"car_demo1"} 
        data={categories}
        // setCategories={setCategories}
      />
      <Product 
        data={products}
      />
      <ImageSlideshow />
      <Service />
      {/* <Offer /> */}
      <Work />
      <About header />
      <div className="section-t-md-space">
        <div className="contact-map height-map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.9056946188866!2d101.5755798!3d3.1196431!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc4fa9c341816b%3A0x5cd5504d3a153618!2sCC%20Autoworld%20Sdn.%20Bhd.!5e0!3m2!1sen!2smy!4v1747665302769!5m2!1sen!2smy" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="map" />
        </div>
      </div>
      {/* <Testimonials type={"car_demo1"} animation /> */}
    </>
  );
};

export default CarDemo1Container;
